import React, { useEffect, useState } from 'react';
import { CircularProgress, Box } from '@mui/material';
import Typography from '@mui/material/Typography';

const CircularProgressWithTimer = () => {
  const [progress, setProgress] = useState(0);
  const [seconds, setSeconds] = useState(25); // assuming a 25 seconds countdown

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 100 : prevProgress + 4));
      setSeconds((prevSeconds) => (prevSeconds <= 0 ? 0 : prevSeconds - 1));
    }, 200);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" position="relative">
      <CircularProgress variant="determinate" value={progress} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="caption" component="div" color="textSecondary">
          {`${Math.round(seconds / 5)}s`}
        </Typography>
      </Box>
    </Box>
  );
};

export default CircularProgressWithTimer;